/**
 * FoloLabs lockup (mark + logotype). Brand assets v1, 2026-05-17.
 * `currentColor` lets the consumer set the colour via CSS or Mantine `c="aquifer.6"`.
 */
export function Logo({ size = 32 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 420 80"
      height={size}
      aria-label="FoloLabs"
      role="img"
    >
      <g fill="none" stroke="currentColor" strokeWidth={4} strokeLinecap="round">
        <circle cx={40} cy={40} r={30} />
        <line x1={22} y1={30} x2={54} y2={30} />
        <line x1={26} y1={40} x2={58} y2={40} />
        <line x1={22} y1={50} x2={54} y2={50} />
      </g>
      <text
        x={92}
        y={56}
        fontFamily="'IBM Plex Sans', 'Inter', system-ui, -apple-system, sans-serif"
        fontSize={48}
        fontWeight={600}
        letterSpacing="-1.2"
        fill="currentColor"
      >
        Folo
        <tspan fontWeight={400}>Labs</tspan>
      </text>
    </svg>
  );
}
